var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.accessDetails && _vm.staffDetails)?_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"short-title":"SchoolDock","title":"SchoolDock"}},[(_vm.staffDetails)?_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
            name: 'Dashboard',
            icon: 'fa fa-tv text-primary',
            path: '/dashboard',
        }}}),(_vm.staffDetails.isPortalAdmin == true  || _vm.staffDetails.isPrincipal == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Academic Management',
            icon: 'fa fa-sliders-h text-blue',
            path: '/school/academic-management',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isRegistrar == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Admission Management',
            icon: 'fa fa-ticket text-blue',
            path: '/school/admission',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isClassTeacher == true || _vm.staffDetails.isDailyAttendanceManager == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Attendance Management',
            icon: 'fa fa-user-clock text-blue',
            path: '/school/attendance-management',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isPrincipal == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Career & Guidance',
            icon: 'fa fa-graduation-cap text-blue',
            path: '/school/career-and-guidance',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isPrincipal == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Certificates',
            icon: 'fa fa-certificate text-blue',
            path: '/school/certificates',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isPrincipal == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Communication',
            icon: 'fa fa-comments text-blue',
            path: '/school/communication',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isPrincipal == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Discipline Management',
            icon: 'fa fa-gavel text-blue',
            path: '/school/discipline-management',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isPrincipal == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Document Management',
            icon: 'fa fa-folder text-blue',
            path: '/school/document-management',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isPrincipal == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Events Management',
            icon: 'fa fa-calendar text-blue',
            path: '/school/events-management',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isPrincipal == true || _vm.staffDetails.isHOD == true || _vm.staffDetails.isClassTeacher == true || _vm.staffDetails.isSubjectTeacher == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Examination & Assessment',
            icon: 'fa fa-computer text-blue',
            path: '/school/examination-and-assessment',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isPrincipal == true || _vm.staffDetails.isBursar == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Finance Management',
            icon: 'fa fa-hand-holding-dollar text-blue',
            path: '/school/finance-management',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isPrincipal == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Health Management',
            icon: 'fa fa-heartbeat text-blue',
            path: '/school/health-management',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isHostelMaster == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Hostel Management',
            icon: 'fa fa-bed text-blue',
            path: '/school/hostel-management',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isPrincipal == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Inventory & Assets',
            icon: 'fa fa-boxes text-blue',
            path: '/school/inventory-and-assets',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isPrincipal == true || _vm.staffDetails.isHOD == true || _vm.staffDetails.isClassTeacher == true || _vm.staffDetails.isSubjectTeacher == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Learning Management',
            icon: 'fa fa-book-reader text-blue',
            path: '/school/learning-management',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isLibraryAdmin == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Library Management',
            icon: 'fa fa-book text-blue',
            path: '/school/library-management',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isPrincipal == true || _vm.staffDetails.isClassTeacher == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Reports & Analytics',
            icon: 'fa fa-chart-line text-blue',
            path: '/school/reports-and-analytics',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isPrincipal == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'School Details',
            icon: 'fa fa-school text-blue',
            path: '/school/school-details',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isPrincipal == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'School Website CMS',
            icon: 'fa fa-globe text-blue',
            path: '/school/school-website',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isRegistrar == true || _vm.staffDetails.isPrincipal == true || _vm.staffDetails.isHOD == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Staff Information',
            icon: 'fa fa-id-card text-blue',
            path: '/school/staff-management',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isRegistrar == true || _vm.staffDetails.isPrincipal == true || _vm.staffDetails.isHOD == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Student Information (SIS)',
            icon: 'fa fa-id-card text-blue',
            path: '/school/student-information-system',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isPrincipal == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Subscription',
            icon: 'fa fa-credit-card text-blue',
            path: '/school/subscription',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isPrincipal == true || _vm.staffDetails.isHOD == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Timetable Management',
            icon: 'fa fa-calendar text-blue',
            path: '/school/timetable-management',
        }}}):_vm._e(),(_vm.staffDetails.isPortalAdmin == true || _vm.staffDetails.isPrincipal == true)?_c('sidebar-item',{attrs:{"link":{
            name: 'Transport Management',
            icon: 'fa fa-bus text-blue',
            path: '/school/transport-management',
        }}}):_vm._e(),_c('div',{staticClass:"dropdown-divider"}),_c('sidebar-item',{attrs:{"link":{ name: 'Log Out', icon: 'fa fa-right-from-bracket text-blue', path: '/' }},on:{"click":_vm.logout}})],1):_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }